<div class="sidebar-wrapper" id="sidebar" [class.show]="layoutService.isMobileSidebarOpen()">
  <!-- Brand Logo / Identity -->
  <a routerLink="/dashboard" class="sidebar-brand" (click)="onLinkClick()">
    <i class="bi bi-plus-lg"></i>
    <span>Equity+</span>
  </a>

  <!-- Navigation Menu -->
  <div class="flex-grow-1 overflow-y-auto">
    <!-- Group: Menu -->
    <div class="sidebar-menu-section">
      <div class="sidebar-menu-title">Menu</div>
      <ul class="sidebar-menu-list">
        <li class="sidebar-menu-item">
          <a
            routerLink="/dashboard"
            routerLinkActive="active"
            class="sidebar-menu-link"
            title="Dashboard"
            (click)="onLinkClick()"
          >
            <i class="bi bi-grid-fill"></i>
            <span>Dashboard</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Group: Gestão -->
    <div class="sidebar-menu-section">
      <div class="sidebar-menu-title">Gestão</div>
      <ul class="sidebar-menu-list">
        <!-- Pessoas -->
        <li class="sidebar-menu-item">
          <a
            routerLink="/persons"
            routerLinkActive="active"
            class="sidebar-menu-link"
            title="Pessoas"
            (click)="onLinkClick()"
          >
            <i class="bi bi-people-fill"></i>
            <span>Pessoas</span>
          </a>
        </li>

        <!-- Categorias Genéricas -->
        <li class="sidebar-menu-item">
          <a
            routerLink="/categories"
            routerLinkActive="active"
            class="sidebar-menu-link"
            title="Categorias"
            (click)="onLinkClick()"
          >
            <i class="bi bi-tags-fill"></i>
            <span>Categorias</span>
          </a>
        </li>

        <!-- Produtos -->
        <li class="sidebar-menu-item">
          <a
            routerLink="/products"
            routerLinkActive="active"
            class="sidebar-menu-link"
            title="Produtos"
            (click)="onLinkClick()"
          >
            <i class="bi bi-box-seam-fill"></i>
            <span>Produtos</span>
          </a>
        </li>

        <!-- Serviços -->
        <li class="sidebar-menu-item">
          <a
            routerLink="/services"
            routerLinkActive="active"
            class="sidebar-menu-link"
            title="Serviços"
            (click)="onLinkClick()"
          >
            <i class="bi bi-wrench-adjustable-circle-fill"></i>
            <span>Serviços</span>
          </a>
        </li>

        <!-- Movimentações (antigo Vendas) -->
        <li class="sidebar-menu-item">
          <a
            routerLink="/movements"
            routerLinkActive="active"
            class="sidebar-menu-link"
            title="Movimentações"
            (click)="onLinkClick()"
          >
            <i class="bi bi-arrow-left-right"></i>
            <span>Movimentações</span>
          </a>
        </li>

        <!-- Financeiro (Contas a Receber e Contas a Pagar) Submenu -->
        <li class="sidebar-menu-item">
          <a
            href="javascript:void(0);"
            class="sidebar-menu-link"
            [class.active]="isFinanceRouteActive()"
            [attr.aria-expanded]="isFinanceOpen() || isFinanceRouteActive()"
            (click)="toggleFinanceSubmenu()"
            title="Financeiro"
          >
            <i class="bi bi-receipt-cutoff"></i>
            <span>Financeiro</span>
            <i class="bi bi-chevron-down dropdown-caret"></i>
          </a>
          <ul class="sidebar-submenu" *ngIf="isFinanceOpen() || isFinanceRouteActive()">
            <li>
              <a
                routerLink="/duplicatas/receber"
                routerLinkActive="active text-white fw-bold"
                class="sidebar-submenu-link d-flex align-items-center gap-2"
                (click)="onLinkClick()"
              >
                <i class="bi bi-arrow-down-left-circle text-success"></i>
                <span>Contas a Receber</span>
              </a>
            </li>
            <li>
              <a
                routerLink="/duplicatas/pagar"
                routerLinkActive="active text-white fw-bold"
                class="sidebar-submenu-link d-flex align-items-center gap-2"
                (click)="onLinkClick()"
              >
                <i class="bi bi-arrow-up-right-circle text-danger"></i>
                <span>Contas a Pagar</span>
              </a>
            </li>
          </ul>
        </li>

        <!-- Bancos -->
        <li class="sidebar-menu-item">
          <a
            routerLink="/banks"
            routerLinkActive="active"
            class="sidebar-menu-link"
            title="Bancos"
            (click)="onLinkClick()"
          >
            <i class="bi bi-bank"></i>
            <span>Bancos</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Group: Administração -->
    @if (userContext.isGlobalAdmin() || userContext.isOperational()) {
      <div class="sidebar-menu-section">
        <div class="sidebar-menu-title">Administração</div>
        <ul class="sidebar-menu-list">
          <li class="sidebar-menu-item">
            <a
              routerLink="/companies"
              routerLinkActive="active"
              class="sidebar-menu-link"
              title="Empresas"
              (click)="onLinkClick()"
            >
              <i class="bi bi-building-fill"></i>
              <span>Empresas</span>
            </a>
          </li>
        </ul>
      </div>
    }
  </div>

  <!-- Sidebar Profile Card (Dynamic Footer) -->
  <div class="sidebar-profile">
    <img
      [src]="authService.user()?.photoURL || '/assets/img/avatars/no-photo.jpg'"
      alt="Avatar do Usuário"
      class="sidebar-profile-img"
      onerror="this.src='/assets/img/avatars/no-photo.jpg'"
    />
    <div class="sidebar-profile-info">
      <div class="sidebar-profile-name">
        {{ authService.user()?.displayName || 'Usuário' }}
      </div>
      <div class="sidebar-profile-email">
        {{ authService.user()?.email || 'usuario@equityplus.com' }}
      </div>
    </div>
  </div>
</div>
